import React from 'react';
import { BranchModel } from '@/typings/models/Location';
import styles from './index.less';
import { Flex } from 'antd';
import { F } from '@/utils/intl';

interface BranchSummaryProps {
  branch: BranchModel;
}

const BranchSummary: React.FC<BranchSummaryProps> = ({ branch }) => {
  if (!branch) return null;

  return (
    <div className={styles.branchSummary}>
      <span className={styles.branchName}>{branch.name}</span>
      <Flex align={"center"} className={styles.address} gap={8}>
        <div>📍</div>
        {branch.address || (
          <F id="pages.locations.noAddressProvided" defaultMessage="No address provided" />
        )}
      </Flex>
    </div>
  );
};

export default BranchSummary;
